/**
 * Route configuration for controlling layout behavior.
 * Add route paths here to customize their display properties.
 */

/**
 * Routes that should NOT display the left sidebar.
 * Use path patterns that match the route path (without query params).
 * 
 * Examples:
 * - '/pricing' - exact match
 * - '/onboarding' - exact match  
 * - '/ai' - exact match
 */
export const ROUTES_WITHOUT_SIDEBAR = [
    '/',
    '/pricing',
    '/ai',
    '/templates',
    '/sitemap',
]

export const ROUTES_WITH_FREE_GENERATION_BANNER = [
    '/',
]

/**
 * Check if a given pathname should hide the sidebar.
 * @param {string} pathname - The current route pathname (e.g., '/pricing')
 * @returns {boolean} - True if sidebar should be hidden
 */
export function shouldHideSidebar(pathname) {
    return ROUTES_WITHOUT_SIDEBAR.some(route => pathname === route || pathname.startsWith(`${route}/`))
}

export function shouldShowFreeGenerationBanner(pathname) {
    return ROUTES_WITH_FREE_GENERATION_BANNER.some(route => pathname === route || pathname.startsWith(`${route}/`))
}
